/**
 * @generated SignedSource<<a1c8390fcd60d116e74f9ee34075d8aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CompanyCandidateDocumentStatusEnum = "COMPLETED" | "IN_ANALYSIS" | "PENDING" | "WRONG" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DependentDocuments_query$data = {
  readonly dependent: {
    readonly documentTypesNotSubmitted?: ReadonlyArray<{
      readonly code: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"DocumentCard_document">;
    }>;
    readonly documents?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly companyStatus: CompanyCandidateDocumentStatusEnum;
          readonly documentType: {
            readonly code: string;
            readonly " $fragmentSpreads": FragmentRefs<"DocumentCard_document">;
          };
          readonly id: string;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id: string;
    readonly name?: string;
    readonly requiredDocs?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly documentType: {
            readonly code: string;
            readonly name: string;
            readonly " $fragmentSpreads": FragmentRefs<"DocumentCard_document">;
          };
          readonly id: string;
        };
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "DependentDocuments_query";
};
export type DependentDocuments_query$key = {
  readonly " $data"?: DependentDocuments_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"DependentDocuments_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DocumentCard_document"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "dependent",
          "documents"
        ]
      }
    ]
  },
  "name": "DependentDocuments_query",
  "selections": [
    {
      "alias": "dependent",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyRequiredDocsConnection",
              "kind": "LinkedField",
              "name": "requiredDocs",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CompanyRequiredDocsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CompanyRequiredDocs",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Document",
                          "kind": "LinkedField",
                          "name": "documentType",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v2/*: any*/),
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Document",
              "kind": "LinkedField",
              "name": "documentTypesNotSubmitted",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": "documents",
              "args": null,
              "concreteType": "CandidateDocumentConnection",
              "kind": "LinkedField",
              "name": "__Documents_documents_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CandidateDocumentEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CandidateDocument",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "companyStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Document",
                          "kind": "LinkedField",
                          "name": "documentType",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfoExtended",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "CandidateDependent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "fb198117b0912bca0d4b966cb7561cb8";

export default node;
